import React from 'react';
import { motion } from 'framer-motion';
import { ChoiceCue } from '../ChoiceCue';
import { relevance, studyBridge } from '../../../data/snak';
import { heroOct } from '../../../data/teaser';
const EASE = [0.23, 1, 0.32, 1] as const;
interface RelevancePageProps {
  selected: string | null;
  onSelect: (id: string) => void;
}
export function RelevancePage({
  selected,
  onSelect
}: RelevancePageProps) {
  return <div className="flex min-h-0 flex-1 flex-col px-10 py-7" data-id="element-223" data-mp="2g98u3artf2f0">
      <div className="flex items-start gap-10" data-id="element-224" data-mp="2l7adxxx2f5rj">
        <motion.h2 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="max-w-xl flex-1 font-display text-[29px] font-semibold leading-[1.06] tracking-tight text-navy" data-id="element-225" data-mp="2l82apc2ef9je">
          {relevance.headline[0]}
          <br data-id="element-226" data-mp="1xhg13gcqxh7a" />
          <span className="text-blue" data-id="element-227" data-mp="1xfvi8nzsnmp9">{relevance.headline[1]}</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.26,
        delay: 0.08,
        ease: EASE
      }} className="w-[38%] shrink-0 border-l border-line pl-8 text-[13.5px] leading-relaxed text-mut" data-id="element-228" data-mp="22ey9n5mupuer">
          {relevance.copy}
        </motion.p>
      </div>

      <motion.figure initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.12,
      ease: EASE
    }} className="relative mt-6 min-h-0 flex-1 overflow-hidden rounded-2xl bg-ink" data-id="element-229" data-mp="1rditynr9fzwa">
        <img src={heroOct.src} alt={heroOct.alt} className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-230" data-mp="1hdrvyc3hr2rg" />
        <div className="scanlines pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-231" data-mp="18f6iuwgsgfy2" />

        <figcaption className="absolute inset-x-0 bottom-0 flex flex-wrap items-center gap-2 px-5 pb-4 pt-10" data-id="element-232" data-mp="36uat9rncsctk">
          <span className="mr-2 text-[9px] uppercase tracking-micro text-sky/60" data-id="element-233" data-mp="32th8361apc4d">
            Already visible in routine OCT
          </span>
          {studyBridge.variables.map((v, i) => <motion.span key={v} initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.22,
          delay: 0.24 + i * 0.05,
          ease: EASE
        }} className="rounded-full border border-mint/40 bg-ink/70 px-3 py-1 font-display text-[12px] font-semibold tracking-tight text-mint" data-id="element-234" data-mp="14wqyjzxgo23h" data-mpi={i}>
              {v}
            </motion.span>)}
        </figcaption>
      </motion.figure>

      <motion.p initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.26,
      delay: 0.18,
      ease: EASE
    }} className="mt-6 font-display text-[20px] leading-snug text-navy" data-id="element-235" data-mp="19vtzb86erm5n">
        {relevance.cue.question}
      </motion.p>

      <div className="mt-4" data-id="element-236" data-mp="3fhwuuwjzi49">
        <ChoiceCue cue={relevance.cue} selected={selected} onSelect={onSelect} data-id="element-237" data-mp="3froso15rzcl" />
      </div>
    </div>;
}